import { render, staticRenderFns } from "./DisplayDocument.vue?vue&type=template&id=c87a57c8&scoped=true&"
import script from "./DisplayDocument.vue?vue&type=script&lang=js&"
export * from "./DisplayDocument.vue?vue&type=script&lang=js&"
import style0 from "./DisplayDocument.vue?vue&type=style&index=0&id=c87a57c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87a57c8",
  null
  
)

export default component.exports